import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  Grid,
  Alert,
  Divider
} from '@mui/material';
import { motion } from 'framer-motion';
import TestConnection from '../components/common/TestConnection';
import TestDataFetch from '../components/common/TestDataFetch';
import CognitoTest from '../components/common/CognitoTest';
import GlobalTest from '../components/common/GlobalTest';
import TestCognitoSetup from '../components/common/TestCognitoSetup';
import SimpleCognitoTest from '../components/common/SimpleCognitoTest';
import DirectLoginTest from '../components/common/DirectLoginTest';

const TestPage: React.FC = () => {
  // Only show in development environment
  if (!import.meta.env.DEV) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          Test page is only available in development environment.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" gutterBottom>
          Development Test Page
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          This page contains various test components for debugging and development purposes.
        </Typography>

        <Grid container spacing={3}>
          {/* Connection Tests */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Connection Tests
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TestConnection />
            </Paper>
          </Grid>

          {/* Global Polyfill Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Global Polyfill Test
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <GlobalTest />
            </Paper>
          </Grid>

          {/* Cognito Setup Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Cognito Setup Test
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TestCognitoSetup />
            </Paper>
          </Grid>

          {/* Simple Cognito Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Simple Cognito Test
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <SimpleCognitoTest />
            </Paper>
          </Grid>

          {/* Direct Login Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Direct Login Test
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <DirectLoginTest />
            </Paper>
          </Grid>

          {/* Cognito Authentication Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Cognito Authentication Test
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <CognitoTest />
            </Paper>
          </Grid>

          {/* Data Fetch Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Data Fetch Test
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TestDataFetch />
            </Paper>
          </Grid>
        </Grid>
      </motion.div>
    </Box>
  );
};

export default TestPage;
